import type {
  ConsultOutcome,
  ConsultSignalType
} from "services/types/consult-debriefs.type";

/**
 * Signal tones follow the soft-background / dark-ink pill system used by the
 * Reviews and Administration features (alpha() over palette colors, no new hex).
 * goal → secondary (what the patient wants), objection → warning (friction),
 * buying_signal → success (momentum).
 */
export const SIGNAL_TONES: Record<
  ConsultSignalType,
  { label: string; palette: "secondary" | "warning" | "success" }
> = {
  goal: { label: "Goal", palette: "secondary" },
  objection: { label: "Objection", palette: "warning" },
  buying_signal: { label: "Buying Signal", palette: "success" }
};

export const CONSULT_OUTCOME_LABELS: Record<ConsultOutcome, string> = {
  fitting_scheduled: "Fitting Scheduled",
  trial_started: "Trial Started",
  follow_up_booked: "Follow-up Booked",
  declined: "Declined",
  undecided: "Undecided"
};

/** "HH:MM:SS(.ffffff)" DRF duration → "MM:SS" (or "H:MM:SS" past an hour). */
export function formatTranscriptTimestamp(
  duration: string | null
): string | null {
  if (!duration) return null;
  const match = duration.match(/^(\d+):(\d{2}):(\d{2})/);
  if (!match) return null;
  const [, hours, minutes, seconds] = match;
  return Number(hours) > 0
    ? `${Number(hours)}:${minutes}:${seconds}`
    : `${minutes}:${seconds}`;
}
